import { render, staticRenderFns } from "./TagsSelect.vue?vue&type=template&id=33ce4849&"
import script from "./TagsSelect.vue?vue&type=script&lang=js&"
export * from "./TagsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TagsSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCombobox,VSpacer})
